// extracted by mini-css-extract-plugin
export default {"button":"Y_vJN","withSaveButton":"Jny0u","icon":"JD1QD","text":"djny6","desktopLooks":"tGAz9"};